import styled from "styled-components";

export const Container = styled.div`
  margin: 16px 0;

  .ant-select {
    margin-bottom: 16px;
  }
`;
